import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { messages } from './messages';

export const ReturnsCity = {
  id: 'returnCity',
  displayName: <FormattedMessage {...messages.city} />,
  type: OptionFormTypes.TYPE_IS_FREE_INPUT_DEPRECATED,
  filterValue: 'returnFromCity',

  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_IS_FREE_INPUT_DEPRECATED, criteriaInformations);
  },
};
